import Divider from './Divider'
import LanguageSwitcher from './LanguageSwitcher'
import Link from './Link'
import Logo from './Logo'
import Menu from './Menu'
import QuitLink from './QuitLink'

Menu.Divider = Divider
Menu.LanguageSwitcher = LanguageSwitcher
Menu.Link = Link
Menu.Logo = Logo
Menu.QuitLink = QuitLink

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/index.js